import {
  Box,
  Center,
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import useMobile from "../../hooks/useMobile";

interface ButtonProps {
  onClick: () => void;
  text: string;
  isRed?: boolean;
  isDisabled?: boolean;
}

const ExtraOptionsModal = ({
  isOpen,
  onClose,
  buttons,
}: {
  isOpen: boolean;
  onClose: () => void;
  buttons: ButtonProps[];
}) => {
  const isMobile = useMobile(600);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xs" blockScrollOnMount={false} useInert={false}>
      <ModalOverlay />
      <ModalContent p="0">
        <ModalBody p="0">
          {buttons.map((button: ButtonProps, i: number) => {
            return (
              <Box key={i}>
                <Tooltip
              hasArrow
              bg="black"
              p="8px"
              borderRadius="12px"
              label="Can't edit or delete an event from the past!"
              placement="top"
              isDisabled={!button.isDisabled}
              maxWidth="none"
            >
                <Center
                  h="68px"
                  cursor={button.isDisabled ? "not-allowed" : "pointer"}
                  onClick={!button.isDisabled ? button.onClick : undefined}
                  opacity={button.isDisabled ? 0.5 : 1}
                >
                  <Text
                    fontWeight="500"
                    fontSize={isMobile ? "lg" : "2xl"}
                    color={button.isRed ? "#FF3B30" : "#3B4654"}
                  >
                    {button.text}
                  </Text>
                </Center>
                </Tooltip>
                {i < buttons.length - 1 && <Divider />}
              </Box>
            );
          })}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default ExtraOptionsModal;
